// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListItem_root__YJpsk {
  display: flex;
  align-items: center;
  height: 35px;
  border: 0;
  outline: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  box-sizing: content-box;
  padding-left: 0;
  padding-right: 10px;
  transition: 0.3s all;
}
.MenuListItem_root__YJpsk:hover {
  background: rgba(230, 230, 230, 0.6);
}

.MenuListItem_icon__mizCW {
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
}

.MenuListItem_label__ax56r {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  text-decoration: none;
}

.MenuListItem_disabled__WgfMd {
  background: rgba(226, 226, 226, 0.63);
  cursor: no-drop;
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/MenuList/MenuListItem/MenuListItem.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,YALO;EAMP,SAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EAEA,oBAAA;AAFF;AAIE;EACE,oCAAA;AAFJ;;AAMA;EACE,WAvBO;EAwBP,YAxBO;EAyBP,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;EAEA,qBAAA;AALF;;AAQA;EACE,qCAAA;EACA,eAAA;AALF","sourcesContent":["$height: 35px;\n\n.root {\n  display: flex;\n  align-items: center;\n  height: $height;\n  border: 0;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  cursor: pointer;\n  box-sizing: content-box;\n  padding-left: 0;\n  padding-right: 10px;\n\n  transition: 0.3s all;\n\n  &:hover {\n    background: rgba(230, 230, 230, 0.6);\n  }\n}\n\n.icon {\n  width: $height;\n  height: $height;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 5px;\n}\n\n.label {\n  display: inline-block;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n\n  color: #272A36;\n  //padding-right: 2px;\n  text-decoration: none;\n}\n\n.disabled {\n  background: rgba(226, 226, 226, 0.63);\n  cursor: no-drop;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MenuListItem_root__YJpsk`,
	"icon": `MenuListItem_icon__mizCW`,
	"label": `MenuListItem_label__ax56r`,
	"disabled": `MenuListItem_disabled__WgfMd`
};
export default ___CSS_LOADER_EXPORT___;
